import { NgModule } from '@angular/core';
import { BrowserModule } from '@angular/platform-browser';

import { AppRoutingModule } from './app-routing.module';
import { AppComponent } from './app.component';
import { BrowserAnimationsModule } from '@angular/platform-browser/animations';
import { SharedModule } from './shared/shared.module';
import { HttpInt } from './httpInt';
import { HttpClientModule, HTTP_INTERCEPTORS } from '@angular/common/http';
import { TokenInterceptor } from './shared/Interceptor/token.interceptor';
import { AuthGuardService } from './website/pages/core/services/auth-guard.service';
import { ButtonModule } from 'primeng/button';
import { PdfViewerModule } from 'ng2-pdf-viewer';
import { TableModule } from 'primeng/table';
import { DialogModule } from 'primeng/dialog';
import { TooltipModule } from 'primeng/tooltip';
import { FormsModule } from '@angular/forms';

// import { HttpAuthInterceptorService } from './website/pages/core/services/http-auth-interceptor.service';

declare global {
  interface Navigator {
    msSaveBlob?: (blob: any, defaultName?: string) => boolean
  }
}

@NgModule({
  declarations: [
    AppComponent
  ],
  imports: [
    BrowserModule,
    AppRoutingModule,
    BrowserAnimationsModule,
    SharedModule,
    HttpClientModule,
    ButtonModule,
    PdfViewerModule,  // 👈 aquí
    TableModule,
    DialogModule,
    TooltipModule,
    FormsModule,
  ],
  providers: [
    HttpInt,
    { provide: HTTP_INTERCEPTORS, useClass: TokenInterceptor, multi: true },
    // {
    //     provide: HTTP_INTERCEPTORS,
    //     useClass: HttpAuthInterceptorService,
    //     multi: true
    // },
    AuthGuardService
  ],
  bootstrap: [AppComponent],

})
export class AppModule { }
